/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment";
import "moment/locale/pt-br";

import { useScheduleInfos } from "../../../../../providers/schedule";

import { IDates } from "../../../../../types/SearchAvalilableTimes";
import { IAgenda } from "./types";
import { checkBlockSchedule } from "../AgendamentoCard";
import { useState } from "react";

moment.locale("pt-br");

export const AgendaCard = ({
  agenda,
  start,
  end,
  nextDates,
  previousDates,
  openModal,
}: IAgenda) => {
  const { scheduleInfos } = useScheduleInfos();

  const [showTimes, setShowTimes] = useState(false);

  const handleOpenModal = (schedule: IDates) => {
    scheduleInfos.schedule = schedule;
    openModal();
  };

  const toggleTimes = () => {
    setShowTimes(!showTimes);
  }

  return (
    <>
      <div className="agenda-wrap bg-white p-3 rounded-4">
        <a
          style={{ cursor: "pointer" }}
          onClick={() => previousDates(start, end)}
          className="nav-prev"
        >
          <i className="las la-angle-left"></i>
        </a>
        <a
          style={{ cursor: "pointer" }}
          onClick={() => nextDates(start, end)}
          className="nav-next"
        >
          <i className="las la-angle-right"></i>
        </a>
        <div className="row flex-nowrap text-12">
          {agenda.map((schedule, i) => (
            <div key={i} className="col-4 small">
              <small className="fw-bold d-block text-primary">
                {moment(schedule.data).format("llll").split(",")[0]}
              </small>
              <small className="d-block mb-3">
                {moment(schedule.data).format("L").slice(0, 5)}
              </small>
            </div>
          ))}
        </div>
        <div className="overflow-agenda" style={{maxHeight: (showTimes ? "initial" : 150)}}>
          <div className="row flex-nowrap">
            {agenda.map((schedule, i) => (
              <div key={i} className="col-4">
                {schedule.agendas.map((agenda, index) => {
                  const formatedData = `${schedule.data.split("T")[0]}T${agenda.timeStart}:00`;

                  const isBlocked = checkBlockSchedule(formatedData);
                  const isValidType = [0, 1, 2].includes(agenda.tipo);

                  // classes baseadas nas condições
                  const getClassName = () => {
                    if (isBlocked || !isValidType) return "hour inactive";
                    switch (agenda.tipo) {
                      case 0:
                        return "hour presencial";
                      case 1:
                        return "hour video";
                      case 2:
                        return "hour video-presencial";
                      default:
                        return "hour inactive";
                    }
                  };

                  return (
                    <div
                      key={index}
                      className={getClassName()}
                      onClick={() => {
                        if (agenda.timeStart !== "-" && !isBlocked && isValidType) {
                          handleOpenModal({
                            data: schedule.data,
                            agendas: [agenda],
                          });
                        }
                      }}
                    >
                      {isBlocked || !isValidType ? (
                        agenda.timeStart
                      ) : (
                        <a role="button">{agenda.timeStart}</a>
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
        <div className="text-center pt-3">
          <button className="btn btn-sm btn-outline-primary" onClick={toggleTimes}>{showTimes ? 'Ocultar': 'Exibir mais'} Horários <i className={`las la-arrow-${showTimes ? 'up' : 'down'}`}></i></button>
        </div>
      </div>
      <div className="row justify-content-center pt-3 small">
        <div className="col col-auto">
          <i className="bg-primary rounded-circle me-2 d-inline-block" style={{ width: 10, height: 10 }}></i>
          <small>Presencial</small>
        </div>
        <div className="col col-auto">
          <i className="bg-success rounded-circle me-2 d-inline-block" style={{ width: 10, height: 10 }}></i>
          <small>Teleconsulta</small>
        </div>
      </div>
    </>
  );
};
